import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import FieldIcon from "./FieldIcon";
import PhoneIcon from "../ProfileViewNew/icons/phone-icon.svg";

interface PhoneProps {
  country: string;
  value: any;
  autoFocus?: boolean;
  icon?: React.ReactNode;
  error?: boolean;
  placeholder?: string;
  onChange?(value: any, data: {}): void;
  onBlur?(event: any, data: {}): void;
}

function PhoneNumberInput(props: PhoneProps) {
  const phoneIcon = props.icon ?? <img src={PhoneIcon} alt="" />;

  return (
    <div
      className={[
        "eh-phone-field",
        phoneIcon ? "has-icon" : "",
        props.error ? "is-error" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <FieldIcon>{phoneIcon}</FieldIcon>
      <PhoneInput
        onChange={props.onChange}
        onBlur={props.onBlur}
        country={props.country}
        value={"+" + props.value}
        prefix="+"
        placeholder={props.placeholder || "Phone Number"}
        inputProps={{
          autoFocus: props.autoFocus,
        }}
      />
    </div>
  );
}

export default PhoneNumberInput;
